"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var NoticeBoard_1 = __importDefault(require("./NoticeBoard"));
var SideRight = function (props) {
    var title = props.title, service = props.service;
    return (react_1.default.createElement("div", { className: "right" },
        react_1.default.createElement("div", { className: "right__container" },
            react_1.default.createElement("span", { className: "right__title", "data-testid": "product-service-title" }, title),
            service.map(function (item, index) {
                return react_1.default.createElement(NoticeBoard_1.default, __assign({ key: "".concat(index, "-").concat(item.span) }, (item || {})));
            }))));
};
exports.default = SideRight;
//# sourceMappingURL=SideRight.js.map